import { S, ui, save } from "../../app/store.js";
import { can } from "../../services/access.js";
import { esc } from "../../domain/format.js";
import { today } from "../../domain/dates.js";
import { TIN_RE } from "../../domain/reference.js";
import { log } from "../../services/audit.js";
import { render } from "../../app/shell.js";
import { activateCreation, finishCreation } from "../../components/creation-flow.js";

export function clientForm() {
  if (!can("inv.issue")) return "";
  const existing = S.clients.find((client) => client.id === ui.clientEdit);
  const draft = ui.clientDraft || existing || {};
  return `<details class="panel" id="client-editor"${existing || ui.clientError ? " open" : ""}><summary>${existing ? "Edit client details" : "Add client"}</summary><form id="create-client" class="work-log-form"><p class="small muted">Registered name, TIN and business address are required for every new invoice. Updating a client affects future invoices; issued invoices retain their original details.</p><div class="form"><label>Registered name<input name="name" value="${esc(draft.name || "")}" required></label><label>TIN<input name="tin" value="${esc(draft.tin || "")}" placeholder="000-000-000-00000" pattern="${TIN_RE.source}" data-case="preserve" required></label><label>Business address<input name="address" value="${esc(draft.address || "")}" required></label><label>VAT registration<select name="vat"><option value="yes"${draft.vat === false || draft.vat === "no" ? "" : " selected"}>VAT-registered</option><option value="no"${draft.vat === false || draft.vat === "no" ? " selected" : ""}>Non-VAT</option></select></label></div>${ui.clientError ? `<p class="err" role="alert">${esc(ui.clientError)}</p>` : ""}<div class="row"><button type="submit" class="pri">${existing ? "Update client" : "Save client"}</button>${existing ? '<button type="button" class="out" data-client-edit-cancel>Cancel</button>' : ""}</div></form></details>`;
}

export function personnelForm() {
  if (!can("hr.salary")) return "";
  return `<details class="panel"><summary>Add personnel</summary><form id="create-personnel" class="work-log-form"><div class="form"><label>Full name<input name="name" required></label><label>Position / trade<input name="position" required></label><label>Department<input name="department" required></label><label>Pay basis<select name="pay"><option value="FIELD">Project deployment rate</option><option value="MONTHLY">Monthly salary</option></select></label><label>Monthly basic (₱)<input name="basic" type="number" min="0" step="0.01" value="0" required></label><label>Date hired<input name="hired" type="date" required value="${today()}"></label><label>License type (optional)<input name="licenseType" placeholder="PRC license type"></label><label>License number<input name="licenseNumber" data-case="preserve"></label><label>License valid until<input name="licenseUntil" type="date"></label></div>${ui.personnelError ? `<p class="err">${esc(ui.personnelError)}</p>` : ""}<button type="submit" class="pri">Save personnel</button></form></details>`;
}
export function installSetupForms() {
  document.addEventListener("click", (event) => {
    const button = event.target.closest?.(
      "[data-client-edit], [data-client-edit-cancel]",
    );
    if (!button || !can("inv.issue")) return;
    if (button.hasAttribute("data-client-edit-cancel")) finishCreation();
    else activateCreation("create-client", ui.view);
    ui.clientEdit = button.dataset.clientEdit || null;
    ui.clientDraft = null;
    ui.clientError = "";
    render();
    document.querySelector('#create-client [name="name"]')?.focus();
  });
  document.addEventListener("submit", (event) => {
    if (!["create-client", "create-personnel"].includes(event.target.id))
      return;
    event.preventDefault();
    const data = Object.fromEntries(new FormData(event.target));
    if (event.target.id === "create-client") {
      if (!can("inv.issue")) return;
      ui.clientDraft = data;
      if (
        !data.name.trim() ||
        !TIN_RE.test(data.tin.trim()) ||
        !data.address.trim()
      ) {
        ui.clientError =
          "Enter the registered name, valid TIN and business address.";
        return render();
      }
      const client = {
        id: ui.clientEdit || "C-" + crypto.randomUUID(),
        name: data.name.trim(),
        tin: data.tin.trim(),
        address: data.address.trim(),
        vat: data.vat === "yes",
      };
      const existing = S.clients.find((item) => item.id === ui.clientEdit);
      if (existing) Object.assign(existing, client);
      else S.clients.push(client);
      ui.clientError = "";
      ui.clientDraft = null;
      ui.clientEdit = null;
      log(existing ? "Updated client" : "Added client", client.name);
    } else {
      if (!can("hr.salary")) return;
      const basic = Number(data.basic),
        hasLicense =
          data.licenseType || data.licenseNumber || data.licenseUntil;
      if (
        !data.name.trim() ||
        !data.position.trim() ||
        !data.department.trim() ||
        !data.hired ||
        !Number.isFinite(basic) ||
        basic < 0 ||
        (data.pay === "MONTHLY" && basic <= 0) ||
        (hasLicense &&
          !(data.licenseType && data.licenseNumber && data.licenseUntil))
      ) {
        ui.personnelError =
          "Complete the personnel details. Monthly pay must be positive; licenses need a type, number and expiry date.";
        return render();
      }
      let number = 1;
      while (
        S.employees.some((e) => e.id === "E" + String(number).padStart(3, "0"))
      )
        number++;
      const employee = {
        id: "E" + String(number).padStart(3, "0"),
        name: data.name.trim(),
        position: data.position.trim(),
        dept: data.department.trim(),
        basic,
        pay: data.pay,
        hired: data.hired,
        status: data.pay === "FIELD" ? "PROJECT" : "REGULAR",
        lic: hasLicense
          ? [
              data.licenseType.trim(),
              data.licenseNumber.trim(),
              data.licenseUntil,
            ]
          : null,
        tin: "",
        sss: "",
        philhealth: "",
        pagibig: "",
        osh: false,
      };
      S.employees.push(employee);
      ui.personnelError = "";
      log("Added personnel", employee.name);
    }
    save();
    finishCreation();
    render();
  });
}
